import React, { type ReactNode } from 'react';
import Button from '@atlaskit/button';
import SearchIcon from '@atlaskit/icon/core/migration/search';

type Props = {
	children: ReactNode;
	onClick: () => void;
};

export const AddExistingIssueButton = (props: Props) => {
	const { children, onClick } = props;

	return (
		<Button
			appearance="link"
			iconBefore={<SearchIcon color="currentColor" label="" />}
			isSelected={false}
			onClick={onClick}
			testId="issue-view-common-views.child-issues-panel.inline-create.add-existing-issue-button"
			interactionName="auto-generated.jira-issue-view-common-views.child-issues-panel.view.inline-create.add-existing-issue-button.button"
		>
			{children}
		</Button>
	);
};

AddExistingIssueButton.displayName = 'AddExistingIssueButton';
